import React, { useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import styles from '../mailInfo.module.scss';
import { MailActions, useActions } from '@web-common/state/createStore';
import useReceiverStateSelector from '../../../hooks/useReceiverStateSelector';
import { queryFreeBusyList } from '@web-schedule/service';
import useConferenceSelector from '../../../hooks/useConferenceSelector';
import ArrowRight from '@web-common/components/UI/Icons/svgs/disk/ArrowRight';
import { getIn18Text } from 'api';
function getBusyCount(list) {
    return list.filter(e => e.freeBusyItems.length > 0).length;
}
function getBusyFreeDesc(allCount, busyCount) {
    if (allCount === 0) {
        return getIn18Text('ZANWUHUIYICHENG');
    }
    if (busyCount === 0) {
        return getIn18Text('DANGQIANCHENGYUANJUN');
    }
    if (busyCount !== allCount) {
        return `${allCount}名成员中，${busyCount}在忙`;
    }
    return getIn18Text('SUOYOUCHENGYUANJUN');
}
function getQueryDateParams(conference) {
    const { startDate = moment(), startTime = moment(), endDate = moment(), endTime = moment() } = conference || {};
    const start = startDate === null || startDate === void 0 ? void 0 : startDate.clone().set({
        hours: startTime === null || startTime === void 0 ? void 0 : startTime.hours(),
        minutes: startTime === null || startTime === void 0 ? void 0 : startTime.minutes(),
        seconds: 0,
        millisecond: 0,
    }).toDate();
    const end = endDate === null || endDate === void 0 ? void 0 : endDate.clone().set({
        hours: endTime === null || endTime === void 0 ? void 0 : endTime.hours(),
        minutes: endTime === null || endTime === void 0 ? void 0 : endTime.minutes(),
        seconds: 0,
        millisecond: 0,
    }).toDate();
    return { start, end };
}
const UserBusyFreeIndicatorItem = () => {
    const mailActions = useActions(MailActions);
    const conference = useConferenceSelector();
    const receivers = useReceiverStateSelector();
    const allCount = receivers.length;
    const [busyCount, setBusyCount] = useState(0);
    const handleBusyFreeClick = () => {
        if (allCount > 0) {
            mailActions.doShowUserBusyFree(true);
        }
    };
    const descStr = useMemo(getBusyFreeDesc.bind(null, allCount, busyCount), [allCount, busyCount]);
    useEffect(() => {
        if (conference) {
            const { start, end } = getQueryDateParams(conference);
            queryFreeBusyList({
                start,
                end,
                users: receivers,
            })
                .then(getBusyCount)
                .then(setBusyCount);
        }
    }, [receivers, conference]);
    return (React.createElement("div", { className: classnames([styles.infoItem, styles.infoItemWithoutLine]) },
        React.createElement("span", { className: styles.infoLabel }, getIn18Text('MANGXIAN')),
        React.createElement("span", { className: styles.colonLabel }, ":"),
        React.createElement("div", { className: classnames(styles.conferenceTime) },
            React.createElement("span", { onClick: handleBusyFreeClick, className: classnames(styles.busyFreeDesc, {
                    [styles.enable]: allCount > 0,
                    [styles.free]: busyCount === 0,
                    [styles.busy]: busyCount > 0,
                }) },
                React.createElement("span", null, descStr),
                allCount > 0 && React.createElement(ArrowRight, { opcacity: 1, stroke: busyCount === 0 ? '#386ee7' : '#f74f4f' })))));
};
export default UserBusyFreeIndicatorItem;
